import { Carousel } from './Carousel';
import { Description } from './Description';
import { Donation } from './Donation';
import { Links } from './Links';
import { Header } from './header';
import { Rs } from './rs';

function App() {
  return (
    <div className="grid grid-rows-[auto_auto_1fr] m-auto max-w-lg h-screen">
      <Header />
      <Rs />
      <div className="relative flex-1 h-full">
        <div className="flex flex-col gap-1 flex-1 absolute inset-0 overflow-y-auto justify-start">
          <Description />
          <Donation />
          <Carousel />
          <Links />
        </div>
      </div>
    </div>
  );
}

export default App;
